(function () {
  'use strict';

  var INTERVAL_MS = 4000;
  var MOBILE_QUERY = '(max-width: 989px)';
  var VISIBLE = 2;

  function gapPx(track) {
    var styles = window.getComputedStyle(track);
    return parseFloat(styles.columnGap || styles.gap) || 0;
  }

  function measure(slider, track) {
    var gap = gapPx(track);
    var cardW = (slider.clientWidth - gap * (VISIBLE - 1)) / VISIBLE;
    slider.style.setProperty('--taupe-cat-card-w', cardW + 'px');
    slider.style.setProperty('--taupe-cat-step', cardW + gap + 'px');
    return { cardW: cardW, gap: gap, step: cardW + gap };
  }

  function initCategorySliders() {
    document.querySelectorAll('[data-taupe-category-slider]').forEach(function (slider) {
      if (slider.getAttribute('data-taupe-cat-ready') === 'true') return;
      slider.setAttribute('data-taupe-cat-ready', 'true');

      var track = slider.querySelector('[data-taupe-category-track]');
      var dotsWrap = slider.querySelector('[data-taupe-category-dots]');
      if (!track) return;

      var slides = track.querySelectorAll('.taupe-category-cards__card');
      if (slides.length < 2) return;

      var index = 0;
      var timer;
      var userScrolling = false;
      var scrollEndTimer;
      var mq = window.matchMedia(MOBILE_QUERY);
      var maxIndex = Math.max(0, slides.length - VISIBLE);

      function clearDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
      }

      function buildDots() {
        if (!dotsWrap || dotsWrap.children.length) return;
        var count = maxIndex + 1;
        for (var i = 0; i < count; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'taupe-category-cards__dot' + (i === 0 ? ' is-active' : '');
          dot.setAttribute('data-cat-dot', '');
          dot.setAttribute('aria-label', 'Show categories ' + (i + 1));
          dot.addEventListener('click', function (dotIndex) {
            return function () {
              goTo(dotIndex, true);
              restart();
            };
          }(i));
          dotsWrap.appendChild(dot);
        }
      }

      function scrollTarget(i, metrics) {
        return i * metrics.step;
      }

      function indexFromScroll(metrics) {
        return Math.max(0, Math.min(maxIndex, Math.round(slider.scrollLeft / metrics.step)));
      }

      function goTo(i, smooth) {
        index = i;
        if (mq.matches) {
          var metrics = measure(slider, track);
          slider.scrollTo({
            left: scrollTarget(index, metrics),
            behavior: smooth ? 'smooth' : 'auto'
          });
        } else {
          track.style.transform = '';
          slider.scrollLeft = 0;
        }
        if (dotsWrap) {
          dotsWrap.querySelectorAll('[data-cat-dot]').forEach(function (dot, dotIndex) {
            dot.classList.toggle('is-active', dotIndex === index);
          });
        }
      }

      function next() {
        goTo(index >= maxIndex ? 0 : index + 1, true);
      }

      function stop() {
        window.clearInterval(timer);
        timer = null;
      }

      function restart() {
        stop();
        if (mq.matches && slides.length > VISIBLE && !userScrolling) {
          timer = window.setInterval(next, INTERVAL_MS);
        }
      }

      function onScroll() {
        if (!mq.matches) return;
        var metrics = measure(slider, track);
        var nextIndex = indexFromScroll(metrics);
        if (nextIndex !== index) {
          index = nextIndex;
          if (dotsWrap) {
            dotsWrap.querySelectorAll('[data-cat-dot]').forEach(function (dot, dotIndex) {
              dot.classList.toggle('is-active', dotIndex === index);
            });
          }
        }
      }

      function onUserScrollStart() {
        userScrolling = true;
        stop();
        window.clearTimeout(scrollEndTimer);
      }

      function onUserScrollEnd() {
        window.clearTimeout(scrollEndTimer);
        scrollEndTimer = window.setTimeout(function () {
          userScrolling = false;
          restart();
        }, 3500);
      }

      function onResize() {
        if (mq.matches) {
          measure(slider, track);
          goTo(index, false);
        }
      }

      function activate() {
        maxIndex = Math.max(0, slides.length - VISIBLE);
        if (mq.matches) {
          clearDots();
          measure(slider, track);
          buildDots();
          if (index > maxIndex) index = 0;
          goTo(index, false);
          restart();
        } else {
          stop();
          clearDots();
          index = 0;
          track.style.transform = '';
          slider.scrollLeft = 0;
          slider.style.removeProperty('--taupe-cat-card-w');
          slider.style.removeProperty('--taupe-cat-step');
        }
      }

      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', restart);
      slider.addEventListener('scroll', onScroll, { passive: true });
      slider.addEventListener('touchstart', onUserScrollStart, { passive: true });
      slider.addEventListener('touchend', onUserScrollEnd, { passive: true });
      slider.addEventListener('pointerdown', onUserScrollStart);
      slider.addEventListener('pointerup', onUserScrollEnd);

      window.addEventListener('resize', onResize);

      if (typeof mq.addEventListener === 'function') {
        mq.addEventListener('change', activate);
      } else if (typeof mq.addListener === 'function') {
        mq.addListener(activate);
      }

      activate();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCategorySliders);
  } else {
    initCategorySliders();
  }

  document.addEventListener('shopify:section:load', initCategorySliders);
})();
